import { CSSProperties, useMemo } from 'react'
import { RenderElementProps } from 'slate-react'

import { TNumberedListElement } from 'core-components/library/richTextEditor/interface/custom-types'

import styles from './Ol.module.scss'

interface IProps {
  style: CSSProperties
}

export const Ol = (props: RenderElementProps & IProps) => {
  const olElement = useMemo(() => {
    return props.element as TNumberedListElement
  }, [props.element])

  return (
    <ol
      {...props.attributes}
      start={olElement.start ? +olElement.start : 1}
      className={styles.custom_list}
      style={props.style}
    >
      {props.children}
    </ol>
  )
}
